import { ADDONS_SELECT_TYPE } from '../../utils/constants';
import { procedures, isBookAppointment, surgicalOption, appointmentChannelId, form } from '../../utils/variables';

export function loadAddons(procedureId, category) {
    let addonsContent = ``;
    const procedureList = (appointmentChannelId && form?.appointment_channel?.procedures?.length >= 1) ? form?.appointment_channel?.procedures : procedures;
    const procedure = procedureList.find((i) => i.id === procedureId);

    addonsContent = `
    <div class="popup__background addons" data-procedure-id="${procedureId}" data-category="${category}"></div>
    <div class="addonsSection__content">
        <div class="addonsSection__head">
            <h4 class="addons__title">Select Add-Ons</h4>
            <p class="addons__text">
                ( ${procedure.addons_select_type ===
            ADDONS_SELECT_TYPE.MULTI_SELECT
            ? 'Select all that applies'
            : 'You can only select 1 addon'
        } )
            </p>
        </div>
        <div class="addonsSections__body">
           ${loadAddonList(procedure, category)}
        </div>
        <div class="addonsSection__actions">
            <div class="addons__closeBtn ${procedure?.addons_required ? 'visibility-hidden' : ''}" data-procedure-id="${procedure.id
        }" data-category="${category}">No Add-Ons</div>
            <div class="addons__applyAddonBtn disabled" data-procedure-id="${procedure.id
        }" data-category="${category}">Apply Add-Ons</div>
        </div>
    </div>
    </div>
    `;

    return addonsContent;
}

function loadAddonList(procedure, category) {
    const filterAddOns = procedure?.procedure_addons?.filter(item => !item.deleted_at);
    let list = ``;
    const hiddenQuestionLine = isBookAppointment ? "hidden" : "";
    for (const i of filterAddOns) {
        const price =
            ((i.min_cost ? i.min_cost : 0) +
                (i.max_cost ? i.max_cost : 0)) /
            2;

        const duration = !i.duration
            ? ''
            : i.duration > 1
                ? i.duration + ' minutes'
                : i.duration + ' minute';

        list = list.concat(`
            <div class="addons__content">
                <div class="line__wrapper line__wrapper-addon addon" data-procedure-id="${procedure.id}" data-addon-id="${i.id}">
                    <div class='wrapper__addon'>
                    <div class="addon__checkbox" data-procedure-id="${procedure.id}" data-addon-id="${i.id}">
                        <i class="addon__icon-check ri-check-line"></i>
                    </div>
                    <div class="procedure__infor-wrapper">
                        <div class="addon__name--wrapper">
                            <div class="addon__name">${i.name}</div>
                            <div class="procedure__price-duration ${surgicalOption ? 'hidden' : ''}">${duration}</div>
                        </div>
                        <span class="procedure__price ${isBookAppointment && price !== 0 && !surgicalOption ? "" : "hidden"}">+$${price.toLocaleString('en-US', { maximumFractionDigits: 2 })}</span>
                    </div>
                    ${
                        i.description
                        ? `<span class="procedure__information addon" data-procedure-id="${procedure.id}" data-addon-id="${i.id}" data-category="${category}">
                        <i class="ri-question-line ${hiddenQuestionLine}"></i>
                        </span>`
                        : ""
                    }
                    </div>
                    ${
                        i.description ? `
                        <div class='desc__addons addonBody__wrapper-line' data-procedure-id="${procedure.id}" data-addon-id="${i.id}" data-category="${category}">
                        <p class="addon-body__text">${i.description}</p>
                        </div>
                        `
                        : ''
                    }
                </div>
               
                <div class="addonBody__wrapper" data-procedure-id="${procedure.id
            }" data-addon-id="${i.id}">
                    ${loadAddonInformation(procedure, i, category)}
                </div>
            </div>
        `);
    }
    return list;
}

function loadAddonInformation(procedure, addon, category) {
    return `
    <div class="popup__background addon__information" data-procedure-id="${procedure.id}" data-addon-id="${addon.id}" data-category="${category}">
        <div class="addonBody__content">
            <h4 class="addon-body__title">${addon.name}</h4>
            <p class="addon-body__text">${addon.description}</p>
            <div class="addon__actions">
                <div class="addon-body__close-btn" data-procedure-id="${procedure.id}" data-addon-id="${addon.id}" data-category="${category}">
                    <i class="ri-close-line"></i>
                </div>
                <div class="addonBody__applyBtn" data-procedure-id="${procedure.id}" data-addon-id="${addon.id}" data-category="${category}">
                    Apply
                </div>
            </div>
        </div>
    </div>
    `;
}

